import { Component, Shark, Utils } from "shark-mvc";

import templateContent from "./permission-box.html";

class PermissionBoxComponent extends Component {
	constructor () {
		super("permissionBoxComponent");
		this.addTemplate("", templateContent);
	}

	init () {
		document.addEventListener("mousedown", this.document_mousedownHandler);

		this.set({
			__permissionBoxCSSClasses: "closed",
		});
	}

	// openPermissionBoxBtn_clickHandler (event, data) {
	// 	console.log(data.target);

	// 	document.querySelector(`.permissionBox[data-id="${data.target}PermissionBox"]`).classList.toggle("closed");
	// }

	savePermissionBtn_clickHandler (event, data) {
		// console.log(data);
	}
}

const permissionBoxComponent = new PermissionBoxComponent();

Shark.registerComponent(permissionBoxComponent);

export default permissionBoxComponent;
